module.exports = __webpack_public_path__ + "img/calendar-4.f3697d46.svg";